<template>
  <DragDialog
    class="inner-pop-primary"
    :title="getTitle()"
    :width="588"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="handleCloseDialog">
    <div class="annotation-form-box">
      <el-form
        :model="annotationForm"
        :rules="rules"
        ref="annotationForm"
        class="public-form-primary"
        label-width="100px">
        <el-form-item
          label="批注名称："
          prop="name">
          <el-input
            size="small"
            class="input-primary"
            :maxlength="30"
            show-word-limit
            v-model="annotationForm.name"
            placeholder="请输入批注名称" />
        </el-form-item>
        <el-form-item
          label="批注类型："
          prop="annotationType">
          <div class="grid-item-box">
            <el-select
              class="primary-select left-item-box"
              size="small"
              v-model="annotationForm.annotationType"
              :popper-append-to-body="false"
              @focus="initAnnotationTypeList()"
              placeholder="请选择批注类型">
              <el-option
                v-for="(item, index) in annotationTypeList"
                :key="index"
                :label="item.typeName"
                :value="item.typeValue" />
            </el-select>
            <el-button
              type="primary"
              class="normal-btn normal-ang-btn"
              size="small"
              icon="el-icon-plus"
              @click="openAddAnnotationTypeDialog">
              新建类型
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="严重程度：">
          <el-select
            class="primary-select"
            size="small"
            v-model="annotationForm.severity"
            :popper-append-to-body="false"
            clearable
            placeholder="请选择严重程度">
            <el-option
              v-for="(item, index) in severityTypeList"
              :key="index"
              :label="item.typeName"
              :value="item.typeValue" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <div class="form-label-box">批注描述：</div>
          </template>
          <el-input
            class="input-primary"
            v-model="annotationForm.description"
            autocomplete="off"
            placeholder="请输入批注描述"
            type="textarea"
            maxlength="100"
            rows="4"
            show-word-limit />
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <div class="tooltip-label-box">
              <div>批注视口</div>
              <el-tooltip
                :effect="$theme.tooltipKey()"
                placement="top-start"
                popper-class="common-panel-tooltip-box">
                <div slot="content">编辑批注时视口不支持修改</div>
                <div class="icon-box">
                  <icon-svg icon-class="ic-jieshishuoming" />
                </div>
              </el-tooltip>
              <div>：</div>
            </div>
          </template>
          <div class="img-list-box">
            <div
              class="img-list-item"
              v-for="(item, index) in annotationForm.viewportList"
              :key="index">
              <img :src="item.base64Image" />
              <div
                class="mask-box"
                v-if="isViewportEnabled()">
                <div
                  class="icon-box"
                  @click="deleteViewport(item.index)">
                  <icon-svg
                    icon-class="icon-shanchushikou"
                    size="20" />
                </div>
              </div>
            </div>
            <div
              v-if="isAddViewportDisabled()"
              class="add-viewport-box"
              @click="addViewport">
              <i class="el-icon-plus" />
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="附件："
          class="last-form-item">
          <el-button
            v-show="attachmentList.length < 5"
            size="small"
            class="upload-btn normal-btn normal-ang-btn"
            id="annotation-attachment-upload"
            key="uploadFile"
            @click="uploadAttachment">
            <icon-svg
              icon-class="icon-upload"
              size="14" />
            点击上传
          </el-button>
          <el-button
            v-if="attachmentList.length >= 5"
            size="small"
            class="normal-btn normal-ang-btn"
            :disabled="true">
            <icon-svg
              icon-class="icon-upload"
              size="14" />
            点击上传
          </el-button>
        </el-form-item>
        <div class="attachment-file-list-box">
          <div
            v-for="(item, index) in attachmentList"
            :key="index"
            class="file-item-box">
            <div class="file-info-box">
              <div class="file-name-box">
                <div class="icon-box">
                  <img :src="getFileTypeIcon(item.fileName)" />
                </div>
                <div
                  :class="getAttachmentNameClassName(item)"
                  :title="item.fileName">
                  {{ `${item.fileName}(${getFileSize(item.fileSize)})` }}
                </div>
              </div>
              <div
                class="file-action-btn-box"
                v-if="item.fileStatus === 'uploadSuccess'">
                <el-button
                  v-if="isViewAttachmentBtnVisible(item)"
                  type="text"
                  size="small"
                  title="查看"
                  @click.stop="viewAttachment(item)">
                  <icon-svg icon-class="icon-chakanxiangqing" />
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  title="下载"
                  @click.stop="downloadAttachment(item)">
                  <icon-svg icon-class="icon-xiazai" />
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  title="删除"
                  @click.stop="deleteAttachment(item)">
                  <icon-svg icon-class="icon-shanchushikou" />
                </el-button>
              </div>
            </div>
            <div
              v-if="item.fileStatus === 'uploading'"
              class="custom-progress-box"
              :style="`width:${item.rate}%`" />
            <div
              v-if="item.fileStatus === 'waiting'"
              class="waiting-box">
              等待上传
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="dialog-footer">
      <el-button
        size="small"
        class="normal-ang-btn gr8 hollowOut-btn"
        @click="cancel">
        取消
      </el-button>
      <el-button
        size="small"
        class="primary-btn primary-ang-btn"
        @click="submit">
        确定
      </el-button>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import AttachmentUploader from '@/utils/attachmentUploader'
import { Store } from '@/utils/store'
import { formatFileSize, getTokenId } from '@/utils/generalMethods'

import {
  createSceneAnnotationService,
  updateSceneAnnotationService,
  getAnnotationAttachmentListService,
  deleteAnnotationAttachmentService,
  getAnnotationTypeListService
} from '@/service/interface'

export default {
  data() {
    return {
      annotationForm: {
        name: '',
        annotationType: undefined,
        severity: undefined,
        description: '',
        viewportList: []
      },
      annotationTypeList: [],
      severityTypeList: [
        { typeName: '一般', typeValue: 0 },
        { typeName: '中等', typeValue: 1 },
        { typeName: '严重', typeValue: 2 }
      ],

      currViewportIndex: -1,

      attachmentList: [],

      rules: {
        name: [
          {
            required: true,
            message: '请输入批注名称',
            trigger: 'blur'
          }
        ],
        annotationType: [
          {
            required: true,
            message: '请选择批注类型',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    annotationInfo: Object,
    refreshAnnotationList: Function
  },
  components: {
    DragDialog
  },
  created() {
    let uploaders = Store.uploaders
    let find = uploaders.find(el => el.schemeType === 'Annotation')
    if (find) {
      this.customUploader = find.uploader
    } else {
      // prettier-ignore
      this.customUploader = new AttachmentUploader("Annotation", this.checkFilesCount, this.isSameFileCheck);
    }
  },
  mounted() {
    // prettier-ignore
    this.customUploader.on("attachmentStartUploadFile", this.updateAttachmentList);
    // prettier-ignore
    this.customUploader.on("attachmentUploadSuccess", this.updateAttachmentList);
    this.customUploader.on('updateAttachmentList', this.updateAttachmentList)
  },
  beforeDestroy() {
    // prettier-ignore
    this.customUploader.off("attachmentStartUploadFile", this.updateAttachmentList);
    // prettier-ignore
    this.customUploader.off("attachmentUploadSuccess", this.updateAttachmentList);
    this.customUploader.off('updateAttachmentList', this.updateAttachmentList)
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initData()

        this.$nextTick(() => {
          this.initUploadBtn()
        })
      }
    }
  },
  methods: {
    initData() {
      this.initAnnotationTypeList().then(() => {
        let annotationInfo = this.annotationInfo
        if (annotationInfo.sceneAnnotationId) {
          this.annotationForm = {
            name: annotationInfo.name,
            annotationType: annotationInfo.annotationType,
            severity: annotationInfo.severity,
            description: annotationInfo.description,
            viewportList: annotationInfo.viewportList
          }

          let attachmentList = annotationInfo.attachmentList.map(item => {
            item.id = item.attachmentId
            item.fileName = item.attachmentName
            // 前端自定义状态，用于效果展示(waiting:等待上传, uploading:正在上传, uploadSuccess:上传成功 )
            item.fileStatus = 'uploadSuccess'
            item.rate = 100
            return item
          })
          this.attachmentList = attachmentList
        } else {
          let viewportList = annotationInfo.viewportList
          if (viewportList.length) {
            let viewportInfo = viewportList[0]
            let viewportObj = {
              index: this.annotationForm.viewportList.length + 1,
              base64Image: viewportInfo.base64Image,
              visualAngle: viewportInfo.visualAngle
            }
            if (this.currViewportIndex !== -1) {
              // prettier-ignore
              this.annotationForm.viewportList.splice(this.currViewportIndex, 1, viewportObj);
            } else {
              this.annotationForm.viewportList.push(viewportObj)
            }
          }
        }
      })
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('annotation-attachment-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({
            id: '#annotation-attachment-upload'
          })
        }
      }
    },
    uploadAttachment() {
      this.customUploader.setStatus('waiting')
    },
    viewAttachment(attachmentInfo) {
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = getTokenId()
      let attachmentUrl = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`

      const fileTypeMap = [
        {
          typeValue: 'text',
          subTypes: ['txt']
        },
        {
          typeValue: 'document',
          subTypes: ['docx']
        },
        {
          typeValue: 'excel',
          subTypes: ['xls', 'xlsx']
        },
        {
          typeValue: 'pdf',
          subTypes: ['pdf']
        }
      ]
      let fileName = attachmentInfo.fileName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()
      let find = fileTypeMap.find(item => item.subTypes.includes(fileType))
      let attachmentType = find.typeValue

      const routerUrl = this.$router.resolve({
        path: `../../../attachmentView`,
        query: { attachmentType, attachmentUrl }
      })

      window.open(routerUrl.href, '_blank')
    },
    downloadAttachment(attachmentInfo) {
      let url = ''
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = getTokenId()
      if (window.downloadUrl.includes('http')) {
        url = `${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      } else {
        url = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      }

      this.downloadURL(url, 1)
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    deleteAttachment(attachment) {
      let findIndex = this.attachmentList.findIndex(
        item => item.id === attachment.id
      )
      this.attachmentList.splice(findIndex, 1)

      let attachmentId = attachment.attachmentId
      if (attachmentId) {
        deleteAnnotationAttachmentService(attachmentId).then(response => {
          if (response.isSuccess) {
            this.$message.success('删除成功')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    handleCloseDialog() {
      if (this.annotationInfo.sceneAnnotationId) {
        this.cancel()
      } else {
        this.currViewportIndex = this.annotationForm.viewportList.length - 1
        this.$emit('closeDialog')
        this.$emit('modifyViewport')
      }
    },
    submit() {
      let isExistUploadingFiles = this.attachmentList.some(
        item => item.status === 'uploading'
      )
      if (isExistUploadingFiles) {
        this.$message.warning('附件正在上传中，请稍后再试')
        return
      }

      this.$refs.annotationForm.validate((bool, object) => {
        if (bool) {
          let sceneId = this.$route.query.sceneId
          let params = {
            sceneId,
            name: this.annotationForm.name,
            annotationTypeId: this.annotationForm.annotationType,
            severity:
              this.annotationForm.severity !== ''
                ? this.annotationForm.severity
                : undefined,
            description: this.annotationForm.description
          }
          if (this.annotationInfo.sceneAnnotationId) {
            let attachments = this.attachmentList.map(item => {
              let obj = {
                attachmentId: item.attachmentId,
                fileDataId: item.fileDataId
              }

              return obj
            })
            params.sceneAnnotationId = this.annotationInfo.sceneAnnotationId
            params.attachments = attachments
            updateSceneAnnotationService(params).then(response => {
              if (response.isSuccess) {
                this.refreshAnnotationList().then(() => {
                  this.$message.success('修改批注成功')
                  this.clearForm()
                  this.$emit('closeDialog')
                })
              } else {
                this.$message.error(response.errMsg)
              }
            })
          } else {
            let viewportList = this.annotationForm.viewportList
            let viewPortBase64List = viewportList.map(item => {
              // prettier-ignore
              let base64Image = item.base64Image.replace("data:image/png;base64,", "");
              let obj = {
                base64Image: base64Image,
                visualAngle: item.visualAngle
              }
              return obj
            })
            params.viewPorts = viewPortBase64List
            let fileDataIds = this.attachmentList.map(item => {
              return item.fileDataId
            })
            params.fileDataIds = fileDataIds
            createSceneAnnotationService(params).then(response => {
              if (response.isSuccess) {
                this.refreshAnnotationList().then(() => {
                  this.$message.success('新建批注成功')
                  this.clearForm()
                  this.$emit('closeAnnotationToolBar')
                  this.$emit('closeDialog')
                })
              } else {
                this.$message.error(response.errMsg)
              }
            })
          }
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    cancel() {
      let message = ''
      if (this.annotationInfo.sceneAnnotationId) {
        message = '您确定要放弃当前编辑吗？'
      } else {
        message = '当前批注还未保存，您确定要关闭吗？'
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.annotationInfo.sceneAnnotationId) {
          this.clearForm()
          this.$emit('closeDialog')
        } else {
          this.clearForm()
          this.$emit('closeAnnotationToolBar')
          this.$emit('closeDialog')
        }
      })
    },
    clearForm() {
      this.annotationForm = {
        name: '',
        annotationType: undefined,
        severity: undefined,
        description: '',
        viewportList: []
      }

      this.currViewportIndex = -1
      this.attachmentList = []
    },
    addViewport() {
      this.currViewportIndex = -1
      this.$emit('closeDialog')
      this.$emit('addViewport')
    },
    deleteViewport(index) {
      let findIndex = this.annotationForm.viewportList.findIndex(
        el => el.index === index
      )
      if (findIndex !== -1) {
        this.annotationForm.viewportList.splice(findIndex, 1)
      }
    },
    updateAttachmentList() {
      this.queryAttachmentList().then(attachmentList => {
        // 前端的上传文件列表
        let customUploadList = []
        let uploadFiles = this.customUploader.uploadFiles
        let uploadingFiles = this.customUploader.uploadingFiles
        uploadingFiles.forEach(item => (item.fileStatus = 'uploading'))
        uploadFiles.forEach(item => (item.fileStatus = 'waiting'))

        customUploadList = [
          ...uploadingFiles,
          ...uploadFiles,
          ...attachmentList
        ]

        customUploadList.forEach(item => {
          let find = this.attachmentList.find(el => el.id === item.id)
          if (find) {
            this.$set(find, 'rate', find.rate)
          } else {
            this.attachmentList.push(item)
          }
        })

        this.attachmentList.forEach(item => {
          if (item.rate === 100) {
            item.fileStatus = 'uploadSuccess'
          }
        })
      })
    },
    openAddAnnotationTypeDialog() {
      this.$emit('openAnnotatioTypeDialog')
    },
    initAnnotationTypeList(annotationPointTypeId) {
      return new Promise(resolve => {
        let projectZoneId = this.$route.params.projId
        getAnnotationTypeListService({ projectZoneId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let annotationTypeList = data.map(item => {
              item.typeName = item.name
              item.typeValue = item.annotationTypeId
              return item
            })
            this.annotationTypeList = annotationTypeList
            if (annotationPointTypeId) {
              this.annotationForm.annotationType = annotationPointTypeId
            } else {
              if (!this.annotationForm.annotationType) {
                // prettier-ignore
                this.annotationForm.annotationType = this.annotationTypeList[0]?.typeValue
              }
            }
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryAttachmentList() {
      return new Promise(resolve => {
        let attachmentList = []
        let annotationInfo = this.annotationInfo
        if (annotationInfo.sceneAnnotationId) {
          let annotationId = annotationInfo.sceneAnnotationId
          getAnnotationAttachmentListService(annotationId).then(response => {
            if (response.isSuccess) {
              let data = response.data
              attachmentList = data.map(item => {
                item.id = item.attachmentId
                item.fileName = item.attachmentName
                // 前端自定义状态，用于效果展示(waiting:等待上传, uploading:正在上传, uploadSuccess:上传成功 )
                item.fileStatus = 'uploadSuccess'
                item.rate = 100
                return item
              })
              resolve(attachmentList)
            } else {
              this.$message.error(response.message)
            }
          })
        } else {
          resolve(attachmentList)
        }
      })
    },
    checkFilesCount(fileList) {
      return new Promise(resolve => {
        let attachmentList = [...fileList, ...this.attachmentList]
        if (attachmentList.length > 5) {
          let message = '超出文件数量限制，最多只能上传5个附件，请重新选择文件'
          this.$message.warning(message)
          resolve(false)
        } else {
          resolve(true)
        }
      })
    },
    isSameFileCheck(fileInfo) {
      let isCheckPass = true

      let find = this.attachmentList.find(item => {
        // prettier-ignore
        let isSameFileFlag = item.fileName === fileInfo.fileName && item.fileName.length === fileInfo.fileName.length
        return isSameFileFlag
      })

      if (find) {
        isCheckPass = false
      }

      return isCheckPass
    },
    getTitle() {
      let annotationId = this.annotationInfo.sceneAnnotationId
      let title = annotationId ? '编辑批注' : '新建批注'
      return title
    },
    isViewportEnabled() {
      let viewportList = this.annotationForm.viewportList
      if (!this.annotationInfo.sceneAnnotationId && viewportList.length > 1) {
        return true
      } else {
        return false
      }
    },
    isAddViewportDisabled() {
      let viewportList = this.annotationForm.viewportList
      if (!this.annotationInfo.sceneAnnotationId && viewportList.length < 6) {
        return true
      } else {
        return false
      }
    },
    getFileTypeIcon(fileName) {
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      let imgSrc = ''
      switch (fileType) {
        case 'doc':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'docx':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'xls':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'xlsx':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'pdf':
          imgSrc = require('@/assets/icon/pdf.png')
          break
        case 'txt':
          imgSrc = require('@/assets/icon/txt.png')
          break
        case 'zip':
          imgSrc = require('@/assets/icon/zip.png')
          break
        default:
          imgSrc = require('@/assets/icon/png.png')
          break
      }

      return imgSrc
    },
    isViewAttachmentBtnVisible(attachmentInfo) {
      let fileName = attachmentInfo.fileName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      const visibleFileTypes = ['docx', 'xls', 'xlsx', 'pdf', 'txt']
      return visibleFileTypes.includes(fileType)
    },
    getFileSize(fileSize) {
      let size = formatFileSize(fileSize).fileSize
      let unit = formatFileSize(fileSize).unit
      let fileSizeStr = `${size}${unit}`
      return fileSizeStr
    },
    getAttachmentNameClassName(attachmentInfo) {
      let className = 'name-box text-overflow'
      if (attachmentInfo.fileStatus === 'waiting') {
        className += ' waiting-color'
      } else {
        className += ' normal-color'
      }
      return className
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

:deep(.dialog-content) {
  padding: 0px !important;

  .annotation-form-box {
    padding: 16px;
    .public-form-primary {
      .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
          padding: 0px;
          line-height: 32px;

          &::before {
            margin-right: 2px;
          }
        }

        .form-label-box {
          line-height: 15px;
        }

        .el-form-item__content {
          line-height: 32px;
        }

        .tooltip-label-box {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .name {
            font-size: 14px;
          }

          .icon-box {
            margin: 0px 3px;

            span {
              margin-top: 2px;
            }
          }
        }

        .primary-select {
          width: 100%;

          .el-select-dropdown {
            left: 0px !important;
            margin-top: 4px;
          }
        }

        .img-list-box {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;

          .img-list-item {
            position: relative;
            height: 84px;
            border-radius: 5px;

            &:hover {
              .mask-box {
                display: flex;
              }
            }

            img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
              object-fit: cover;
            }

            .mask-box {
              position: absolute;
              top: 0px;
              left: 0px;
              display: none;
              width: 100%;
              height: 100%;
              border-radius: 5px;
              background: rgba(0, 0, 0, 0.5);

              .icon-box {
                color: #ffffff;
                margin: auto;
                cursor: pointer;
              }
            }
          }

          .add-viewport-box {
            display: flex;
            height: 84px;
            border-radius: 8px;
            border: 1px solid var(--base-border-dark-color18);
            background: var(--viewport-add-pic-bgColor);
            cursor: pointer;

            &:hover {
              background: rgba(37, 128, 255, 0.05);
              border: 1px solid var(--base-border-dark-color18);

              i {
                color: var(--base-primary-bgColor);
              }
            }

            i {
              margin: auto;
              font-size: 30px;
              color: var(--viewport-add-pic-icon-bgColor);
            }
          }
        }

        .upload-btn {
          margin-top: 5px;

          .webuploader-pick {
            color: var(--attachment-upload-text-color);

            span {
              &:first-child {
                display: flex;
                align-items: center;

                span {
                  margin-right: 8px;
                }
              }
            }
          }
        }

        .el-button {
          span {
            &:first-child {
              display: flex;
              align-items: center;

              span {
                margin-right: 8px;
              }
            }
          }
        }
      }

      .last-form-item {
        margin-bottom: 0px;
      }

      .grid-item-box {
        display: grid;
        grid-template-columns: 4fr 2fr;

        .left-item-box {
          padding-right: 8px;
        }
      }
    }
  }

  .attachment-file-list-box {
    font-size: 14px;
    margin-left: 80px;

    .file-item-box {
      position: relative;
      margin: 4px 0px;
      border-radius: 8px;

      .file-info-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 8px;
        background: var(--attachment-bg-color);
        border-radius: 8px;
        border: 1px solid var(--attachment-border-color);

        .file-name-box {
          display: flex;
          align-items: center;
          overflow: hidden;

          .icon-box {
            img {
              vertical-align: bottom;
            }
          }

          .name-box {
            margin-left: 5px;
          }

          .normal-color {
            color: var(--attachment-normal-color);
          }

          .waiting-color {
            color: var(--attachment-waiting-color);
          }
        }

        .file-action-btn-box {
          flex-shrink: 0;
          width: 80px;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .el-button--text {
            margin-left: 0px;
            color: var(--attachment-normal-color);
            padding: 2px;

            &:hover {
              background: var(--base-bg-dark-color33);
            }
          }
        }
      }

      .custom-progress-box {
        position: absolute;
        top: 0px;
        width: 0;
        height: 100%;
        background: var(--base-bg-light-color70);
        z-index: 2;
        border-radius: 8px;
      }

      .waiting-box {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        z-index: 2;
        border-radius: 8px;
        text-align: right;
        padding: 0px 8px;
        line-height: 32px;
        color: var(--base-dark21-color);
      }
    }
  }
}
</style>
